<template>
  <div class="cancel-flow-pause-feature">
    <img
      class="cancel-flow-pause-feature__image"
      src="@/assets.app/images/18514_hero.svg"
      width="415"
      height="240"
      alt=""
    />
    <h2 class="cancel-flow-pause-feature__title">
      Are you interested in pausing your subscription?
    </h2>
    <div class="cancel-flow-pause-feature__feedback">
      <button
        class="cancel-flow-pause-feature__feedback-btn"
        aria-label="Not interested"
        :disabled="canceling"
        @click="onFeedback('not_interested')"
      >
        <span class="iconfont idislike" />
      </button>
      <div class="cancel-flow-pause-feature__feedback-divider" />
      <button
        class="cancel-flow-pause-feature__feedback-btn"
        aria-label="Interested"
        :disabled="canceling"
        @click="onFeedback('interested')"
      >
        <span class="iconfont ilike" />
      </button>
    </div>
  </div>

  <div class="cancel-flow-popup__footer">
    <AppButton
      :danger="true"
      :loading="canceling"
      :disabled="canceling"
      class="cancel-flow-popup__cta"
      @click="onEndMembership"
    >
      End my membership
    </AppButton>
  </div>
</template>

<script setup lang="ts">
import { onMounted } from 'vue'

import AppButton from '@/app/components/button/AppButton.vue'
import { BillingView } from '@/models/billing'
import type { ReasonValue } from '@/models/billing.cancelFlow'
import { Mixpanel } from '@/analytics/mixpanel'

const props = defineProps<{
  billing: BillingView
  canceling: boolean
  reason: ReasonValue | null
}>()
const emit = defineEmits<{
  (e: 'feedback', value: 'interested' | 'not_interested'): void
  (e: 'continueCancel'): void
}>()

onMounted(() => {
  Mixpanel.trackCancelFlowStepShown(props.billing, 'feature', props.reason)
})

function onFeedback(value: 'interested' | 'not_interested'): void {
  Mixpanel.trackCancelFlowButtonClick(
    props.billing,
    'feature',
    value,
    props.reason,
  )
  emit('feedback', value)
}

function onEndMembership(): void {
  Mixpanel.trackCancelFlowButtonClick(
    props.billing,
    'feature',
    'end_membership',
    props.reason,
  )
  emit('continueCancel')
}
</script>
